var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8379 22.4678C15.0765 22.4678 12.8379 24.7064 12.8379 27.4678V58.1779C12.8379 60.9393 15.0765 63.1779 17.8379 63.1779H63.2993C66.0607 63.1779 68.2993 60.9393 68.2993 58.1779V33.6264C68.2993 30.8649 66.0607 28.6264 63.2993 28.6264H41.3926C39.9052 28.6264 38.4949 27.9641 37.545 26.8195L35.4331 24.2747C34.4832 23.13 33.073 22.4678 31.5855 22.4678H17.8379Z",
    fill: "#513DC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7891 16.3096H50.2793C53.0407 16.3096 55.2793 18.5481 55.2793 21.3096V22.4682H36.905C35.3716 22.4682 33.9229 21.7645 32.9749 20.5591L32.8495 20.3997C32.328 19.7366 31.6472 19.2162 30.8705 18.8871L24.7891 16.3096Z",
    fill: "#513DC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5371 16.3091C10.7757 16.3091 8.53711 18.5477 8.53711 21.3091V52.0192C8.53711 54.7806 10.7757 57.0192 13.5371 57.0192H58.9985C61.76 57.0192 63.9985 54.7806 63.9985 52.0192V27.4677C63.9985 24.7063 61.76 22.4677 58.9985 22.4677H37.2111C35.7515 22.4677 34.3647 21.8298 33.4148 20.7216L31.1294 18.0552C30.1795 16.9469 28.7927 16.3091 27.3331 16.3091H13.5371Z",
    fill: "url(#paint0_linear_2137_19213)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2545 30.0094C17.4003 28.4689 18.6938 27.292 20.2412 27.292H31.6005C33.1479 27.292 34.4414 28.4689 34.5872 30.0094L35.9569 44.4856C36.1235 46.2462 34.7387 47.7681 32.9702 47.7681H18.8715C17.103 47.7681 15.7182 46.2462 15.8848 44.4855L17.2545 30.0094Z",
    fill: "url(#paint1_linear_2137_19213)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9781 31.1523C29.9781 33.3948 28.1602 35.2127 25.9177 35.2127C23.6753 35.2127 21.8574 33.3948 21.8574 31.1523",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9626,
    cy: 27.2921,
    r: 1.402,
    fill: "#513DC3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8747,
    cy: 27.2921,
    r: 1.402,
    fill: "#513DC3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19213",
    x1: 63.9985,
    y1: 36.6642,
    x2: 8.53711,
    y2: 36.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19213",
    x1: 25.9208,
    y1: 27.292,
    x2: 25.9208,
    y2: 47.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3099"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution2);
export default __webpack_public_path__ + "static/media/nhnsolution2.0b727af2c6ef78fa4c320d853a8a56f9.svg";
export { ForwardRef as ReactComponent };